import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_RECOMMENDATIONS } from "../domain";

import { recommendationsApi } from "@api/services";
import { roleGuard } from "@api";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const setRecommendationImInterested = async (
  recommendationId: number,
): Promise<void> => {
  recommendationsApi.recommendationsControllerSetRecommendationImInterested(
    recommendationId,
  );
};

export const useSetRecommendationImInterested = (
  user: UserProfileDto | null,
): {
  setRecommendationImInterested: UseMutateFunction<void, Error, number, unknown>;
  setRecommendationImInterestedEnabled: boolean;
  isSuccessRecommendationImInterested: boolean;
  isPendingRecommendationImInterested: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_RECOMMENDATIONS],
    mutationFn: enabled ? setRecommendationImInterested : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_RECOMMENDATIONS] });
    },
  });

  return {
    setRecommendationImInterested: mutate,
    setRecommendationImInterestedEnabled: enabled,
    isSuccessRecommendationImInterested: isSuccess,
    isPendingRecommendationImInterested: isPending,
  };
};
